import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { DashboardController } from "./dashboard.controller";
import { DashboardService } from "./dashboard.service";
import { QuestionBankService } from "../create-questions/create-question.service";
import { CreateQuestion } from "../create-questions/entities/create-question";
import { QuestionBankCreationModule } from "../create-questions/create-question-module";
import { QuestionPapers } from "../ai-generated-qp/entities/question-papers";
import { AIGeneratedQpModule } from "../ai-generated-qp/ai-generated-qp.module";



@Module({
    imports: [TypeOrmModule.forFeature([CreateQuestion,QuestionPapers]),QuestionBankCreationModule,AIGeneratedQpModule],
    controllers: [DashboardController],
    providers: [DashboardService,],
    exports: [DashboardService]
})

export class DashboardModule { }